module.exports = __webpack_public_path__ + "img/65.a06fce6e.jpg";